import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderGradient } from '@components/ui/header-gradient/header-gradient';
import { Logo } from '@components/ui/logo/logo';
import { Back } from '@components/ui/back/back';
import { RouterModule } from '@angular/router';
import { Loader } from '@components/ui/directives/loader';
import { Message } from '@components/ui/message/message';
import { Brand } from '@components/ui/brand/brand';
import { Avatar } from '@components/ui/avatar/avatar';
import { Share } from '@components/ui/share/share';
import { SwipeHint } from './swipe-hint/swipe-hint';
import { Skeleton } from '@components/ui//directives/skeleton';
import { Searchable } from '@components/ui/directives/searchable';
import { Console } from '@components/ui/console/console';
import { AltImg } from '@components/ui/directives/alt-img';
import { InputPreview } from '@components/ui/directives/input-preview';
import { Progress } from '@components/ui/progress/progress';
import { Notification } from '@components/ui/notification/notification';
import { Sticky } from '@components/ui/directives/sticky';
import { Rate } from '@components/ui/rate/rate';
import { FormsModule } from '@angular/forms';
import { FlyTo } from '@components/ui/directives/fly-to';
import { ScrollTo } from '@components/ui/directives/scroll-to';
import { CommingSoon } from '@components/ui/comming-soon/comming-soon';
import { RadialProgress } from '@components/ui/radial-progress/radial-progress';
import { AutoFocus } from '@components/ui/directives/auto-focus';
import { ImgCardType, ImgMarketPlacePipe, ImgSymbol } from '@components/ui/pipe/img-element-pipe';
import { ValConditionPipe } from '@components/ui/pipe/val-condition-pipe';
import { Copy } from '@components/ui/directives/copy';


@NgModule({
  declarations: [
    HeaderGradient,
    Logo,
    Back,
    Loader,
    Message,
    Brand,
    Avatar,
    Share,
    SwipeHint,
    Skeleton,
    Searchable,
    Console,
    AltImg,
    InputPreview,
    Progress,
    Notification,
    Sticky,
    Rate,
    FlyTo,
    ScrollTo,
    CommingSoon,
    RadialProgress,
    AutoFocus,
    ImgMarketPlacePipe,
    ImgCardType,
    ImgSymbol,
    ValConditionPipe,
    Copy
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  exports: [
    HeaderGradient,
    Logo,
    Back,
    Loader,
    Message,
    Brand,
    Avatar,
    Share,
    SwipeHint,
    Skeleton,
    Searchable,
    Console,
    AltImg,
    InputPreview,
    Progress,
    Notification,
    Sticky,
    Rate,
    FlyTo,
    ScrollTo,
    CommingSoon,
    RadialProgress,
    AutoFocus,
    ImgMarketPlacePipe,
    ImgCardType,
    ImgSymbol,
    ValConditionPipe,
    Copy
  ]
})
export class UiModule { }
